
import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../../constants/Options';

interface ProductUnitFormViewProps {
    handleFormSuccess: () => void;
}
const ProductUnitCreateView: React.FC<ProductUnitFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        unit_name :"",
        short_name:"",
        remarks :"",
        status :"",
        
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("unit_name", values.unit_name);
            formData.append("short_name", values.short_name);
            formData.append("status", values.status==="1"?"1":"0");
            formData.append("remarks", values.remarks);
            try {
                await postDataToTheServer(AppURL.InventoryURL + 'inventory/product/unit/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        action.resetForm();
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message});
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Product Unit Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='unit_name'
                            label='Unit Name'
                            handleChange={handleChange}
                            value={values.unit_name}
                            error={errors.unit_name}
                            handleBlur={handleBlur}
                            touched={touched.unit_name}
                            required={true}
                            placeholder='Enter Unit Name'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='short_name'
                            label='Short Name'
                            handleChange={handleChange}
                            value={values.short_name}
                            error={errors.short_name}
                            handleBlur={handleBlur}
                            touched={touched.short_name}
                            required={true}
                            placeholder='Enter Short Name'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Active'
                            options={YesNoOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={true}
                            placeholder='Select Active/Inactive'
                            name='status'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'status' } });
                            }}
                            value={values.status}
                            touched={touched.status}
                            errors={errors.status}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={errors.remarks}
                            handleBlur={handleBlur}
                            touched={touched.remarks}
                            required={false}
                            placeholder='Enter Remarks'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ProductUnitCreateView